<template><section><h2>search-bar</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-search-bar v-model="value" @input="input()"></weui-search-bar>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-search-bar v-model=&quot;value&quot; @input=&quot;input()&quot;&gt;&lt;/weui-search-bar&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        value: ''
      }
    },
    methods: {
      input: function() {
        console.log(this.value)
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Attribute</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value(v-model)</td>
<td>搜索内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    data() {
      return {
        value: ''
      }
    },
    methods: {
      input: function() {
        console.log(this.value)
      }
    }
  }
</script>